import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, Output, Renderer2 } from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { RadioItem } from './radio-item';

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioGroupComponent),
    multi: true
};

@Component({
    selector: 'radiogroup',
    templateUrl: './radiogroup.component.html',
    styleUrls: ['./radiogroup.component.less'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR,
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => RadioGroupComponent),
            multi: true
        }

    ],
    standalone: true,
    imports: [SharedGuiSmallModule]
})
export class RadioGroupComponent implements ControlValueAccessor {

    @Input()
    public orientationVertical: boolean = false;

    @Input()
    items: Array<RadioItem> = [];

    @Input()
    defaultValue: string = "";
    
    @Input()
    labelSpace: number = 5;

    @Input()
    itemSpace: number = 20;

    @Output()
    private beforeSelect = new EventEmitter<any>();

    @Output()
    private select = new EventEmitter<any>();

    @Output()
    private change = new EventEmitter<any>();

    private _value: string = '';

    disabled: boolean = false;

    private hoveredItem: RadioItem | undefined;

    constructor(private element: ElementRef,
        private renderer: Renderer2,
        private chDet: ChangeDetectorRef) {



    }

    ngOnInit(): void {

        this._value = this.defaultValue;
        this.handleChange();

    }



    ngAfterViewInit(): void {


    }

    handleChange(): void {

    
    }

    onSelect(item: RadioItem): void {
        this.beforeSelect.emit();

        this.value = item.getInputValue();

        this.select.emit(this.value);
    }

    isLast(item: RadioItem): boolean {

        let index;
        this.items.forEach((it, i) => {

            if (it == item) index = i;

        });

        if (this.items && (index == this.items.length - 1)) return true;

        return false;

    }

    public disable(): void {
        this.disabled = true;
    }

    public enable(): void {
        this.disabled = false;
    }

    public onItemEnter(ev: MouseEvent, item: RadioItem) {

        this.hoveredItem = item;

    }

    public onItemLeave(ev: MouseEvent, item: RadioItem) {

        this.hoveredItem = undefined;

    }

    public imgClass(item: RadioItem): string {

        if (item.inputValue === this.value) return 'radio-checked';

        if (this.hoveredItem === item) return 'radio-empty-hover';

        return 'radio-empty';

    }

    public colorClass(item: RadioItem): string {

        if (item.inputValue === this.value) return 'checked-color';

        if (this.hoveredItem === item) return 'empty-hover-color';

        return 'empty-color';

    }

    get value(): any { return this._value; };

    set value(v: any) {

        if ((v !== this._value) && (v != null)) {
            this._value = v;
            this.change.emit(v);
            this.handleChange();
            this.onChange(v);

           
        }

    }

    validate(c: FormControl<boolean>) {
    }

    writeValue(value: any) {

        this.value = value;

    }

    onChange = (_: Function) => { };
    onTouched = () => { };
    registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
    registerOnTouched(fn: () => void): void { this.onTouched = fn; }


}